module.exports = "<div class=\"form-control component-songrid-control\"> <div class=ui-songrid-box> <div class=songGrid></div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/songrid-control/songrid-control.wx.html
// module id = 4718
// module chunks = 50